import { ROLE_TYPES } from "../constants/roles";

/**
 * Returns true when the current user has the ER_SUPERADMIN role.
 * Roles can arrive in different shapes/casing depending on API serialization.
 */
export const isErSuperAdmin = (user) => {
  const roles = user?.roles ?? user?.Roles ?? [];
  if (!Array.isArray(roles)) return false;
  return roles.some(
    (r) => String(r || "").toUpperCase().trim() === ROLE_TYPES.ER_SUPERADMIN
  );
};

